
import { mapShareContactTypes, ShareContactType } from "../../Share/ShareContactType";
import { mapShareContacts, ShareContact } from "../ShareContactInterface";
import { mapSharedFolderBy, SharedFolderBy } from "../SharedFolderBy";

// this is for project folders
export interface Service {
    folder_for: string;
    folder_id: number;
    project_id: number;
    folder: string;
    type: string;
    service_name: string | null;
    display_name: string | null;
    folder_type: string | null;
    add_default_id: number | null;
    assign: ShareContact[];
    contact: ShareContactType[];
    feature_name: string | null;
    feature_key_name: string | null;
    category: 'Others' | 'Building Control' | null;
    shared_by: SharedFolderBy | null;
    file_path: string | null;
    can_delete_folder: 1 | 0;
    can_view: 1 | 0;
    can_edit: 1 | 0;
    can_delete: 1 | 0;
}

export const mapCustomService = (data: any): Service => {
    if (!data) {
        throw new Error('Invalid service type');
    }

    const customService: Service = {
        folder_for: data.folder_for,
        folder_id: data.folder_id,
        project_id: data.project_id,
        folder: data.folder,
        type: data.type,
        service_name: data.service_name ?? null,
        display_name: data.display_name ?? null,
        folder_type: data.folder_type ?? null,
        add_default_id: data.add_default_id ?? null,
        assign: Array.isArray(data.assign) ? mapShareContacts(data.assign) : [],
        contact: mapShareContactTypes(data.contact),
        feature_name: data.feature_name ?? null,
        feature_key_name: data.feature_key_name ?? null,
        category: data.category,
        shared_by: (data.shared_by !== null) ? mapSharedFolderBy(data.shared_by) : null,
        file_path: data.file_path !== null ? data.file_path : null,
        can_delete_folder: data.can_delete_folder,
        can_view: data.can_view,
        can_edit: data.can_edit,
        can_delete: data.can_delete,
    }

    return customService;
}

export const mapCustomServices = (data: any[]): Service[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid service data');
    }

    return data.map(mapCustomService);
};